import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle } from 'lucide-react';
import { CollapsibleSection } from './IntelligenceUIComponents';

export const RiskVolatilitySection = ({ data }) => {
  const rv = data?.riskVolatility;
  if (!rv) return null;
  
  const mcs = rv.mediaControversySensitivity;
  const lfr = rv.leadershipFatigueRisk;
  const pdr = rv.performanceDependencyRisk;
  const pof = rv.publicOpinionFluctuation;
  
  return (
    <CollapsibleSection title="Risk & Volatility Analysis" icon={AlertTriangle} defaultOpen={false} badge="Risk Assessment">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className={`border ${mcs.level === 'Elevated' ? 'border-warning/30' : 'border-border/50'}`}>
          <CardContent className="p-4">
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-sm font-medium">Media Controversy</h4>
              <Badge className={mcs.level === 'Elevated' ? 'bg-warning/20 text-warning' : 'bg-stable/20 text-stable'}>{mcs.level}</Badge>
            </div>
            <span className="text-3xl font-bold">{mcs.score}</span>
            <div className="mt-2 h-2 bg-muted/30 rounded-full overflow-hidden">
              <div className={`h-full rounded-full ${mcs.score > 50 ? 'bg-warning' : 'bg-stable'}`} style={{ width: `${mcs.score}%` }} />
            </div>
            <p className="text-xs text-muted-foreground mt-2">{mcs.description}</p>
          </CardContent>
        </Card>
        
        <Card className="border-border/50">
          <CardContent className="p-4">
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-sm font-medium">Leadership Fatigue</h4>
              <Badge className="bg-stable/20 text-stable">{lfr.level}</Badge>
            </div>
            <span className="text-3xl font-bold">{lfr.score}</span>
            <div className="mt-2 h-2 bg-muted/30 rounded-full overflow-hidden">
              <div className="h-full rounded-full bg-stable" style={{ width: `${lfr.score}%` }} />
            </div>
            <p className="text-xs text-muted-foreground mt-2">{lfr.historicalPattern}</p>
          </CardContent>
        </Card>
      </div>

      <Card className="mt-4 border-border/50">
        <CardContent className="p-4">
          <h4 className="text-sm font-medium mb-3">Performance Dependency - Score: {pdr.score}</h4>
          <Badge className={pdr.level === 'High' ? 'bg-warning/20 text-warning' : 'bg-stable/20 text-stable'}>{pdr.level}</Badge>
        </CardContent>
      </Card>

      <div className="mt-4 p-4 bg-muted/20 rounded-lg">
        <h4 className="text-sm font-medium mb-2">Opinion Fluctuation Index</h4>
        <span className="text-2xl font-bold">{pof.index}</span>
        <span className="text-sm text-muted-foreground ml-2">Band: {pof.volatilityBand}</span>
      </div>
    </CollapsibleSection>
  );
};

export default RiskVolatilitySection;
